/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import { Block } from 'particles'
export default props => <Block {...props} />


// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Block/index.js